import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import Datatable from "../../components/datatable/Datatable";
import SponsoredService from "../../services/sponsored";
import { useEffect, useRef, useState } from "react";
import Toast from "../../components/toast/Toast";
import columnsHeader from "./ColumnsHeaderData";
import SponsoredHistoryModal from "./SponsoredHistoryModal";
import Loader from "../../components/spinner/Spinner";
import Backdrop from "../../components/backdrop/Backdrop";
import SponsoredModal from "./SponsoredModal";
import { Box, Grid } from "@mui/material";

const Sponsored = () => {
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [toastStatus, setToastStatus] = useState("");
  const [backdrop, setBackdrop] = useState(false);
  const [isSidebar, setIsSidebar] = useState(null);
  const [sponsorHistoy, setSponsorHistoy] = useState([]);
  const [rowDataHistoySponsor, setRowDataHistoySponsor] = useState([]);
  const [openHistoy, setOpenHistoy] = useState(false);
  const [openSponsored, setOpenSponsored] = useState(false);

  useEffect(() => {
    getAllSponsor();
  }, []);

  // const getAllSponsor = async () => {
  //   setLoading(true);
  //   try {
  //     let { data } = await SponsoredService.fetchSponsor();
  //     let dupMentorIds = data.data.reduce((a, b) => {
  //       a[b.kid_id] = ++a[b.kid_id] || 0;
  //       return a;
  //     }, {});
  //     setSponsorHistoy(data.data.filter((p) => dupMentorIds[p.kid_id]));
  //     // setRowData([...new Map(data.data.map((d) => [d["kid_id"], d])).values()]);
  //     setRowData(
  //       Object.values(
  //         data.data
  //           .sort(
  //             (a, b) =>
  //               new Date(b.mentored_on_date) - new Date(a.mentored_on_date)
  //           ) // Sort by latest mentored_on_date
  //           .reduce((acc, curr) => {
  //             // Only keep the most recent record for each kid_id
  //             if (!acc[curr.kid_id]) {
  //               acc[curr.kid_id] = curr;
  //             }
  //             return acc;
  //           }, {})
  //       )
  //     );
  //     setLoading(false);
  //   } catch (err) {
  //     setLoading(false);
  //     console.log(err);
  //     setRowData([]);
  //   }
  // };
  const getAllSponsor = async () => {
    setLoading(true);
    try {
      const { data } = await SponsoredService.fetchSponsor();
      const sponsorList = Array.isArray(data?.data) ? data.data : [];

      const sortedSponsors = [...sponsorList].sort(
        (a, b) => new Date(b.mentored_on_date) - new Date(a.mentored_on_date),
      );

      const latestActiveByKid = new Map();
      const latestActiveSponsors = [];
      const sponsorHistoryList = [];

      for (const sponsor of sortedSponsors) {
        if (!sponsor.is_active) continue;
        const existing = latestActiveByKid.get(sponsor.kid_id);
        if (!existing) {
          latestActiveByKid.set(sponsor.kid_id, sponsor);
          latestActiveSponsors.push(sponsor);
        }
      }

      for (const sponsor of sortedSponsors) {
        const latestForKid = latestActiveByKid.get(sponsor.kid_id);
        if (latestForKid && latestForKid.id !== sponsor.id) {
          sponsorHistoryList.push(sponsor);
        }
      }

      setRowData(latestActiveSponsors);
      setSponsorHistoy(sponsorHistoryList);
    } catch (err) {
      console.error("Error fetching sponsor data:", err);
      setRowData([]);
      setSponsorHistoy([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async ({ id, kid_id }) => {
    if (!window.confirm("Are you sure to delete the record?")) return;
    setBackdrop(true);
    try {
      await SponsoredService.deleteSponsor({ id, kid_id });
      setToastOpen(true);
      setToastMsg("Sponsored deleted successfully");
      setToastStatus("success");
      setOpen(false);
      setBackdrop(false);
      getAllSponsor();
    } catch (err) {
      setToastOpen(true);
      setToastMsg("Something went wrong!");
      setToastStatus("error");
      console.log(err);
      setBackdrop(false);
    }
  };

  // const onHistoy = (kid_id) => {
  //   setOpenHistoy(true);
  //   if (kid_id) {
  //     setRowDataHistoySponsor(sponsorHistoy.filter((k) => kid_id == k.kid_id));
  //   }
  // };

  const onHistoy = (kid_id) => {
    if (!kid_id) return;

    setOpenHistoy(true);

    // Filter and sort in one clean step
    const kidHistory = sponsorHistoy
      .filter((sponsor) => sponsor.kid_id === kid_id)
      .sort(
        (a, b) => new Date(b.mentored_on_date) - new Date(a.mentored_on_date),
      );

    setRowDataHistoySponsor(kidHistory);
  };

  const onSubmit = async (values) => {
    setBackdrop(true);
    try {
      if (values.id) {
        await SponsoredService.updateSponsor(values);
      } else {
        await SponsoredService.addSponsor(values);
      }
      setToastOpen(true);
      setToastMsg(`Sponsor ${values?.id ? "updated" : "created"} successfully`);
      setToastStatus("success");
      setOpenSponsored(false);
      getAllSponsor();
      setSelectedRow({});
      setBackdrop(false);
    } catch (err) {
      console.log(err);
      setToastOpen(true);
      setBackdrop(false);
      setToastStatus("error");
      setToastMsg(err?.response?.data?.message || "Something went wrong!");
    }
  };

  return (
    <div className="list">
      <Sidebar isSidebar={isSidebar} />
      <div className="listContainer">
        <Navbar isSidebar={isSidebar} setIsSidebar={setIsSidebar} />
        {loading ? (
          <Loader />
        ) : (
          <>
            <Datatable
              pageTitle={"Sponsored"}
              columnsData={columnsHeader.columnsData}
              actionColumn={columnsHeader.actionHeader(
                handleDelete,
                onHistoy,
                sponsorHistoy,
              )}
              addBtnTxt={"Add Sponsor"}
              onAddBtn={() => {
                setOpenSponsored(true);
                setSelectedRow({});
              }}
              rowData={rowData}
              defaultSortModel={[{ field: "mentored_on_date", sort: "desc" }]}
            />
          </>
        )}
      </div>
      {toastOpen && (
        <Toast
          toastOpen={toastOpen}
          toastClose={() => setToastOpen(false)}
          toastMsg={toastMsg}
          toastStatus={toastStatus}
        />
      )}
      {openHistoy && (
        <SponsoredHistoryModal
          open={openHistoy}
          onClose={() => setOpenHistoy(false)}
          rowData={rowDataHistoySponsor}
        />
      )}

      {openSponsored && (
        <SponsoredModal
          open={openSponsored}
          onClose={() => setOpenSponsored(false)}
          selectedRow={selectedRow}
          onSubmit={onSubmit}
        />
      )}
      {backdrop && <Backdrop />}
    </div>
  );
};

export default Sponsored;
